// @noflow
import './styles.css';

import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import messages from './intl.js';
import PropTypes from 'prop-types';
import * as React from 'react';

const propTypes = {
    canDecrease: PropTypes.bool,
    canIncrease: PropTypes.bool,
    decreaseZoom: PropTypes.func.isRequired,
    increaseZoom: PropTypes.func.isRequired,
    zoomLevel: PropTypes.number.isRequired
};

const ZoomControls = ({ canIncrease, canDecrease, decreaseZoom, increaseZoom, zoomLevel }) => (
    <div className="zoom-controls">
        <span>Zoom:</span>
        <button
            className={classnames('zoom-controls__plus', {
                'zoom-controls__plus--disabled': !canIncrease
            })}
            data-qa="logs-timeline-zoom-plus"
            onClick={canIncrease && increaseZoom}
        >
            +
        </button>
        {zoomLevel && (
            <FormattedMessage {...messages[zoomLevel]}>
                {message => <span className="zoom-controls__interval">{message}</span>}
            </FormattedMessage>
        )}
        <button
            className={classnames('zoom-controls__minus', {
                'zoom-controls__minus--disabled': !canDecrease
            })}
            data-qa="logs-timeline-zoom-minus"
            onClick={canDecrease && decreaseZoom}
        >
            -
        </button>
    </div>
);

ZoomControls.propTypes = propTypes;

export default ZoomControls;



// WEBPACK FOOTER //
// ./src/components/widgets/logs-timeline/zoom/index.js